import React from 'react';
import get from 'lodash/get';
import { ScoreCell, ScoreTotalCell, ScoreTodayCell } from 'components/scores';
import LeaderboardWidgetNameContent from './leaderboard-widget-name-content';
import LeaderboardTeeTimesGroup from '../../leaderboard/js/components/leaderboard-tee-times-group';
import { stateTypes } from './enums';

const LeaderboardWidgetCell = ({
    state, player, scoringLeaderboard, isPlayOff
}) => {
    const renderCell = () => {
        switch (state) {
            case stateTypes.POSITION:
                return get(player, 'position.displayValue') || '-';
            case stateTypes.NAME:
                return <LeaderboardWidgetNameContent player={player} />;
            case stateTypes.TEE:
                return (scoringLeaderboard.currentRound === get(scoringLeaderboard, 'currentRound')) &&
                        <LeaderboardTeeTimesGroup player={player} scoringLeaderboard={scoringLeaderboard} isPlayOff={isPlayOff}
                        />;
            case stateTypes.TO_PAR:
                return <ScoreTotalCell par={player.toPar} />;
            case stateTypes.HOLE:
                return <ScoreCell>{player.hole || '-'}</ScoreCell>;
            case stateTypes.TODAY:
                return <ScoreTodayCell par={player.today} />;
            default:
                return null;
        }
    };

    return (
        <div className={`leaderboard-widget__cell is-${state}`}>
            {renderCell()}
        </div>
    );
};

export default LeaderboardWidgetCell;
